export const seriesActionTypes = {
    FETCH_NETFLIX_SERIES_REQUEST: 'FETCH_NETFLIX_SERIES_REQUEST',
    FETCH_NETFLIX_SERIES_SUCCESS: 'FETCH_NETFLIX_SERIES_SUCCESS',
    FETCH_NETFLIX_SERIES_FAILURE: 'FETCH_NETFLIX_SERIES_FAILURE',
    LOAD_MORE_NETFLIX_SERIES_SUCCESS: 'LOAD_MORE_NETFLIX_SERIES_SUCCESS',

    FETCH_ACTIONADVENTURE_SERIES_REQUEST: 'FETCH_ACTIONADVENTURE_SERIES_REQUEST',
    FETCH_ACTIONADVENTURE_SERIES_SUCCESS: 'FETCH_ACTIONADVENTURE_SERIES_SUCCESS',
    FETCH_ACTIONADVENTURE_SERIES_FAILURE: 'FETCH_ACTIONADVENTURE_SERIES_FAILURE',
    LOAD_MORE_ACTIONADVENTURE_SERIES_SUCCESS: 'LOAD_MORE_ACTIONADVENTURE_SERIES_SUCCESS',

    FETCH_ANIMATION_SERIES_REQUEST: 'FETCH_ANIMATION_SERIES_REQUEST',
    FETCH_ANIMATION_SERIES_SUCCESS: 'FETCH_ANIMATION_SERIES_SUCCESS',
    FETCH_ANIMATION_SERIES_FAILURE: 'FETCH_ANIMATION_SERIES_FAILURE',
    LOAD_MORE_ANIMATION_SERIES_SUCCESS: 'LOAD_MORE_ANIMATION_SERIES_SUCCESS',

    FETCH_COMEDY_SERIES_REQUEST: 'FETCH_COMEDY_SERIES_REQUEST',
    FETCH_COMEDY_SERIES_SUCCESS: 'FETCH_COMEDY_SERIES_SUCCESS',
    FETCH_COMEDY_SERIES_FAILURE: 'FETCH_COMEDY_SERIES_FAILURE',
    LOAD_MORE_COMEDY_SERIES_SUCCESS: 'LOAD_MORE_COMEDY_SERIES_SUCCESS',

    FETCH_CRIME_SERIES_REQUEST: 'FETCH_CRIME_SERIES_REQUEST',
    FETCH_CRIME_SERIES_SUCCESS: 'FETCH_CRIME_SERIES_SUCCESS',
    FETCH_CRIME_SERIES_FAILURE: 'FETCH_CRIME_SERIES_FAILURE',
    LOAD_MORE_CRIME_SERIES_SUCCESS: 'LOAD_MORE_CRIME_SERIES_SUCCESS',

    FETCH_DOCUMENTARY_SERIES_REQUEST: 'FETCH_DOCUMENTARY_SERIES_REQUEST',
    FETCH_DOCUMENTARY_SERIES_SUCCESS: 'FETCH_DOCUMENTARY_SERIES_SUCCESS',
    FETCH_DOCUMENTARY_SERIES_FAILURE: 'FETCH_DOCUMENTARY_SERIES_FAILURE',
    LOAD_MORE_DOCUMENTARY_SERIES_SUCCESS: 'LOAD_MORE_DOCUMENTARY_SERIES_SUCCESS',

    FETCH_FAMILY_SERIES_REQUEST: 'FETCH_FAMILY_SERIES_REQUEST',
    FETCH_FAMILY_SERIES_SUCCESS: 'FETCH_FAMILY_SERIES_SUCCESS',
    FETCH_FAMILY_SERIES_FAILURE: 'FETCH_FAMILY_SERIES_FAILURE',
    LOAD_MORE_FAMILY_SERIES_SUCCESS: 'LOAD_MORE_FAMILY_SERIES_SUCCESS',

    FETCH_KIDS_SERIES_REQUEST: 'FETCH_KIDS_SERIES_REQUEST',
    FETCH_KIDS_SERIES_SUCCESS: 'FETCH_KIDS_SERIES_SUCCESS',
    FETCH_KIDS_SERIES_FAILURE: 'FETCH_KIDS_SERIES_FAILURE',
    LOAD_MORE_KIDS_SERIES_SUCCESS: 'LOAD_MORE_KIDS_SERIES_SUCCESS',

    FETCH_SCIFIFANTASY_SERIES_REQUEST: 'FETCH_SCIFIFANTASY_SERIES_REQUEST',
    FETCH_SCIFIFANTASY_SERIES_SUCCESS: 'FETCH_SCIFIFANTASY_SERIES_SUCCESS',
    FETCH_SCIFIFANTASY_SERIES_FAILURE: 'FETCH_SCIFIFANTASY_SERIES_FAILURE',
    LOAD_MORE_SCIFIFANTASY_SERIES_SUCCESS: 'LOAD_MORE_SCIFIFANTASY_SERIES_SUCCESS',

    FETCH_TRENDING_SERIES_REQUEST: 'FETCH_TRENDING_SERIES_REQUEST',
    FETCH_TRENDING_SERIES_SUCCESS: 'FETCH_TRENDING_SERIES_SUCCESS',
    FETCH_TRENDING_SERIES_FAILURE: 'FETCH_TRENDING_SERIES_FAILURE',
    LOAD_MORE_TRENDING_SERIES_SUCCESS: 'LOAD_MORE_TRENDING_SERIES_SUCCESS'
}